import { useEffect, useState } from "react";
import Tableheadpanel from "../shared/components/TestSeries/Tableheadpanel";
import AddandEditform from "../shared/components/TestSeries/AddandEditform";
import toast from "react-hot-toast";
import { apideleteTestSeries, apisaveTestseries, apiupdateTestseries, getadminTestseries } from "../shared/services/apiTestSeries/apitestseries";
import Tableview from "../shared/components/TestSeries/Tableview";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export default function Testseriespage () {

    const [visible, setVisible] = useState(false);
    const [formdata, setformdata] = useState({});
    const [page, setPage] = useState(1);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [tableData, setTableData] = useState();
    const [globalFilter, setGlobalFilter] = useState('');
    const [tempFilterValues, setTempFilterValues] = useState([]);
    const [loading, setLoading] = useState(false);
    const [colFilter, setcolFilter] = useState(null);

    const openform = () => {
        setformdata({});
        setVisible(true);
    };

    const handlechange = (e) => {
        const { name, value } = e.target;
        if (name === 'sections') {
            setformdata(prev => ({ ...prev, sections: value }));
        } else if (e.target.files) {
            setformdata(prev => ({ ...prev, [name]: e.target.files[0] }));
        } else {
            setformdata(prev => ({ ...prev, [name]: value }));
        }
    };

    // Function to fetch data
    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await getadminTestseries({ first, rows, globalFilter });
            if (res?.resdata) {
                setTableData(res.resdata);
            }
        } catch (err) {
            console.log(err);
            toast.error("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    const handlesave = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await apisaveTestseries(formdata);
            console.log(res);
            if (res.message === "Successfully saved") {
                toast.success(res.message);
                setVisible(false);
                setformdata({});
                await fetchData(); // Refetch data after save
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error("Failed to save");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [first, rows, globalFilter]);

    const onPage = (pages) => {
        setPage(pages);
        setFirst(pages.first);
        setRows(rows);
    };

    const clearFilter = (event) => {
        setcolFilter(null);
        setGlobalFilter('');
        setTempFilterValues([]);
        setFirst(0);
    };

    const cusfilter = (field, value) => {
        setcolFilter(prev => ({ ...prev, [field]: { $in: value } }));
        setFirst(0);
    };

    const editfrom = (data) => {
        const deepClonedData = JSON.parse(JSON.stringify(data));
        setformdata(deepClonedData);
        setVisible(true);
    };

    const handleupdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await apiupdateTestseries(formdata);
            console.log(formdata);
            toast.success("Successfully updated");
            setVisible(false);
            await fetchData(); // Refetch data after update
        } catch (err) {
            toast.error("Failed to update");
        } finally {
            setLoading(false);
        }
    };

    const handledelete = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'bg-red-500 ml-2 text-white p-2',
            rejectClassName: 'p-2 outline-none border-0',
            accept: async () => {
                setLoading(true);
                try {
                    await apideleteTestSeries(id);
                    toast.success("Successfully deleted");
                    await fetchData(); // Refetch data after delete
                } catch (err) {
                    toast.error("Failed to delete");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (
        <>
            <Tableheadpanel openform={openform} setGlobalFilter={setGlobalFilter} />
            <AddandEditform 
                visible={visible} 
                setVisible={setVisible} 
                formdata={formdata} 
                handlechange={handlechange} 
                handlesave={handlesave} 
                handleupdate={handleupdate} 
            />
            <Tableview 
                loading={loading} 
                onPage={onPage} 
                tableData={tableData} 
                totallength={tableData?.totallength} 
                cusfilter={cusfilter} 
                editfrom={editfrom}
                clearFilter={clearFilter} 
                tempFilterValues={tempFilterValues} 
                setTempFilterValues={setTempFilterValues} 
                first={first} 
                handledelete={handledelete} 
            />
            <ConfirmDialog />
        </>
    );
}